import { useDiagnosticDefinition } from "@repo/data-store";
import { createFileRoute, redirect, useNavigate } from "@tanstack/react-router";
import { CatalogDefinition, DiagnosticEdit } from "@/features/catalog";
import {
  diagnosticDefinitionRouteId,
  diagnosticDefinitionUrlFromRouteId,
} from "@/features/catalog/lib/diagnostic-definition-route";

export const Route = createFileRoute("/catalog/diagnostics/$diagnosticId_/edit")({
  beforeLoad: ({ context }) => {
    if (!context.permissions.canRead("ActivityDefinition")) throw redirect({ to: "/catalog/procedures" });
  },
  component: DiagnosticEditRoute,
});

function DiagnosticEditRoute() {
  const { diagnosticId } = Route.useParams();
  const { permissions } = Route.useRouteContext();
  const navigate = useNavigate();
  const definition = useDiagnosticDefinition(diagnosticDefinitionUrlFromRouteId(diagnosticId));
  const back = (url = definition?.definitionUrl) =>
    url
      ? navigate({
          to: "/catalog/diagnostics/$diagnosticId",
          params: { diagnosticId: diagnosticDefinitionRouteId(url) },
        })
      : navigate({ to: "/catalog/procedures" });

  if (!definition) {
    return (
      <CatalogDefinition.NotFound label="Diagnostic" backTo="/catalog/procedures" backLabel="Back to procedures" />
    );
  }

  return (
    <DiagnosticEdit
      key={definition.definitionUrl}
      definition={definition}
      canEdit={permissions.canWrite("ActivityDefinition")}
      onDone={back}
      onCancel={() => back()}
    />
  );
}
